import React, { ReactElement } from 'react';
import {
  Button, Col, Row, Text,
} from 'idsk-react-components';
import './navrhAktuEuDetailRow.scss';

interface Props<T> {
  header: string;
  data?: string | number | T[];
  link?: string;
}

const NavrhAktuEuDetailRow = (<T, >({
  header,
  data,
  link,
}: Props<T>): ReactElement => (data ? (
  <Row className="navrh-aktu-eu-detail-row">
    <Col width="one-third">
      <Text type="span" className="information-header">{header}</Text>
    </Col>
    <Col width="two-thirds">
      {link === undefined ? <Text type="p" className="navrh-aktu-eu-detail-row-text">{data}</Text>
        : (
          <Button
            className="akt-eu-link"
            buttonStyle="link"
            size="small"
            onClick={() => {
              window.parent.postMessage({
                type: 'iframe-to-parent-external-route',
                route: link,
              }, '*');
            }}
          >{data}
          </Button>
        )}
    </Col>
  </Row>
  ) : <></>));

export default NavrhAktuEuDetailRow;
